import {Component, Input, OnInit} from '@angular/core';
import {MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle} from '@angular/material/dialog';
import {MatButton} from '@angular/material/button';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {NgOptimizedImage} from '@angular/common';

@Component({
  imports: [
    MatDialogActions,
    MatButton,
    MatDialogClose,
    MatDialogContent,
    MatDialogTitle,
    NgOptimizedImage
  ],
  selector: 'app-dialog-document',
  standalone: true,
  styleUrl: './document.component.scss',
  templateUrl: './document.component.html'
})
export class DocumentDialogComponent implements OnInit {

  /**
   * @description The sanitized data URI containing the document to display in the dialog.
   * @memberof DocumentDialogComponent
   * @name sanitizedDataUri
   * @property
   * @protected
   * @type {SafeResourceUrl}
   */
  protected sanitizedDataUri!: SafeResourceUrl;

  /**
   * @description The data URI containing the document to display in the dialog.
   * @memberof DocumentDialogComponent
   * @name dataUri
   * @property
   * @public
   * @type {string}
   */
  @Input()
  public dataUri!: string;

  /**
   * @description The file name to display in the dialog.
   * @memberof DocumentDialogComponent
   * @name fileName
   * @property
   * @public
   * @type {string}
   */
  @Input()
  public fileName!: string;

  /**
   * @constructor
   * @description Initializes a new instance of the DocumentDialogComponent class.
   * @memberof DocumentDialogComponent
   * @name DocumentDialogComponent#constructor
   * @param {DomSanitizer} sanitizer The Angular service used to sanitize the document URI.
   * @public
   */
  public constructor(
    /**
     * @description The Angular service used to sanitize the document URI.
     * @memberof DocumentDialogComponent
     * @name sanitizer
     * @property
     * @private
     * @type {DomSanitizer}
     */
    private readonly sanitizer: DomSanitizer
  ) {
  }

  /**
   * @description Initializes the component.
   * @memberof DocumentDialogComponent
   * @name DocumentDialogComponent#ngOnInit()
   * @method
   * @public
   * @returns {void}
   */
  public ngOnInit(): void {

    // Bypass the sanitization of the document URI.
    this.sanitizedDataUri = this.sanitizer.bypassSecurityTrustResourceUrl(this.dataUri);
  }
}
